import styled from '@emotion/styled';
import React from 'react';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import { useStaffContext } from '~Scenes/Handy/Context/StaffProvider';
import { Box } from '~Styles';

import { useTableContext } from '~Scenes/Handy/Context/TableContext';
import { useChequeContext } from '~Scenes/Handy/Context/ChequeContext';
import { BackIcon } from '~Scenes/Handy/styles';
import { useI18n } from '~Hooks';

const Wrapper = styled(Box)`
  height: 52px;
  padding: 0 4px;
`;

Wrapper.defaultProps = {
  fluid: true,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const BarContent = styled(Box)`
  display: flex;
  align-items: center;
  flex-grow: 1;
  height: 100%;
`;

const LogoutButton = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--colorBlueGray700);
  height: 34px;
  border-radius: 6px;
  font-size: 14px;
`;

const StaffName = styled(Box)`
  margin-right: 6px;
  font-size: 14px;
  display: flex;
  max-width: 124px;
  align-items: center;
  justify-content: center;
  text-align: right;
  color: var(--colorBlueGray600);
`;

const BackButton = styled(Box)`
  text-transform: capitalize;
  font-weight: bold;
  height: 100%;
  padding-right: 16px; // This is to improve touch area
`;

export default function TopBar() {
  const { i18n } = useI18n();
  const { authedStaff, logoutStaff } = useStaffContext();
  const { selectedTable } = useTableContext();
  const { selectedCheque, setSelectedCheque } = useChequeContext();
  const page = usePage();

  const handleBack = () => {
    // This edge-case is required until we have split tables from the cheque view
    // To back out of the latter we just need to clear the selected Cheque and Table
    if (page.current === 'ordering' && selectedCheque) {
      setSelectedCheque(null);
    } else {
      page.goBack();
    }
  };

  let previousPage: string | null =
    (!!page?.pageHistory?.length && page.pageHistory[page.pageHistory.length - 2]) || null;

  // This is handling a temporary edge case while tables and cheque views are merged
  if (page.current === 'ordering' && selectedTable && selectedCheque) {
    previousPage = 'tables';
  }

  const isQSR = page.current === 'POS';

  return (
    <Wrapper>
      <BarContent display="flex" flexDirection="row">
        {previousPage && (
          <BackButton
            onTouchStart={handleBack}
            padding="xs"
            display="flex"
            flexDirection="row"
            alignItems="center">
            <BackIcon /> {!isQSR && i18n(`Handy.Page.${previousPage}`)}
          </BackButton>
        )}
      </BarContent>
      <BarContent display="flex" justifyContent="flex-end" flexDirection="row">
        <StaffName>{authedStaff?.name}</StaffName>
        {authedStaff && (
          <LogoutButton padding="xs" onTouchEnd={logoutStaff}>
            {i18n('General.Logout')}
          </LogoutButton>
        )}
      </BarContent>
    </Wrapper>
  );
}
